<template lang="html">
  <div class="full-page">
    <i-header title="风险测评" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="risk-start">
        <div class="risk-start-content">
          <div class="risk-start-content-n">{{managerInfo.invenstemName}}</div>
          <div class="risk-start-content-t">测评时间：{{ currentTime | formateTime}}</div>
          <div class="risk-start-content-d">
            <span v-if="managerInfo.sysCode === '1003'">
              风险提示：基金投资需承担各类风险，本金可能遭受损失。同时，还要考虑市场风险，信用风险，流动风险，操作风险等各类投资风险。
              您在紧急认购等过程中应当注意核对自己等风险识别和风险承受能力，选择与自己风险识别能力和风险承受能力相匹配等私募基金。
            </span>
            <span v-if="managerInfo.sysCode === '1004'">
              风险提示：本问卷旨在了解贵单位可承受的风险程度等情况，借此协助贵单位选择合适的金融产品或金融服务类别，以符合贵单位的风险承受能力。
              风险承受能力评估是本公司向客户履行适当性职责的一个环节，其目的是使本公司所提供的金融产品或金融服务与贵单位的风险承受能力等级相匹配。
              本公司特别提醒贵单位：本公司向客户履行风险承受能力评估等适当性职责，并不能取代贵单位自己的投资判断，也不会降低金融产品或金融服务的固
              有风险。同时，与金融产品或金融服务相关的投资风险、履约责任以及费用等将由贵单位自行承担。本公司提示贵单位：本公司根据贵单位提供的信息
              对贵单位进行风险承受能力评估，开展适当性工作。贵单位应当如实提供相关信息及证明材料，并对所提供的信息和证明材料的真实性、准确性、完整
              性负责。本公司建议：当贵单位的各项状况发生重大变化时，需对贵单位所投资的金融产品及时进行重新审视，以确保贵单位的投资决定与贵单位可承
              受的投资风险程度等实际情况一致。本公司在此承诺，对于贵单位在本问卷中所提供的一切信息，本公司将严格按照法律法规要求承担保密义务。
              除法律法规规定的有权机关依法定程序进行查询以外，本公司保证不会将涉及贵单位的任何信息提供、泄露给任何第三方，或者将相关信息用于违法、
              不当用途。
            </span>
          </div>
        </div>
        <div class="foot-btn">
          <cube-button @click="$_handleRisk">开始测评</cube-button>
        </div>
      </div>
    </i-body>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '../commonConfig';

export default {
  data() {
    return {
      currentTime: new Date(),
    };
  },
  mixins: [mixin],
  computed: {
    ...mapGetters(['managerInfo']),
  },
  created() {
    this.$_getCurrentTime();
  },
  methods: {
    $_getCurrentTime() {
      setInterval(() => {
        this.currentTime = new Date();
      }, 1 * 1000);
    },
    $_handleRisk() {
      this.$router.push({
        path: '/risk/risking',
      });
    },
  },
};
</script>

<style lang="scss">
.risk-start {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .risk-start-content {
    background: #fff;
    padding: 24px 16px;
    .risk-start-content-n {
      font-size: 22px;
      color: #222;
      text-align: center;
    }
    .risk-start-content-t {
      font-size: 13px;
      color: #666;
      text-align: center;
      padding: 10px 0;
    }
    .risk-start-content-d {
      font-size: 13px;
      color: #999;
    }
  }
}
</style>
